import type { Language } from '@/backend/market'

export class CashbackTranslationEntity {
  language?: Language
  name?: string | null
  description?: string | null
}
